/* eslint-disable import/no-unresolved */
import API_URLS from "src/config/API_URLS";
import axiosInstance from "src/utils/Axios/axiosInstance";

const logoutCall = async (userId: string) => {
  try {
    const response = await axiosInstance.post(API_URLS.logout, { userId });
    return response;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

export default logoutCall;
